import React from 'react';
import { MenuContainer, ActionButton, SettingsMenu, MenuItem } from '../../styles/WorkspaceSection.styles';
import { SettingsIcon, MembersIcon, MoveIcon, DeleteIcon } from './index';

const WorkspaceMenu = ({ showSettings, onSettingsClick, onManageMembers, onMoveProjects, onDelete, onEdit }) => (
    <MenuContainer>
        <ActionButton onClick={onSettingsClick}>
            <SettingsIcon />
        </ActionButton>
        {showSettings && (
            <SettingsMenu onClick={e => e.stopPropagation()}>
                <MenuItem onClick={onEdit}>
                    <SettingsIcon />
                    Edit workspace
                </MenuItem>
                <MenuItem onClick={onManageMembers}>
                    <MembersIcon />
                    Manage members
                </MenuItem>
                <MenuItem onClick={onMoveProjects}>
                    <MoveIcon />
                    Move all projects to Other
                </MenuItem>
                <MenuItem onClick={onDelete}>
                    <DeleteIcon />
                    Delete workspace
                </MenuItem>
            </SettingsMenu>
        )}
    </MenuContainer>
);

export default WorkspaceMenu;